import React, { useEffect, useState } from "react";
import MultipleTogglePopup from "./MultipleTogglePopup";
import SelectedMultipleDepartmentsList from "./SelectedMultipleDepartmentsList";
import styled from "styled-components";
import MultipleDepartmentsModal from "./MultipleDepartmentsModal";
import { useTranslation } from "react-i18next";

const AddMultipleDepartments = ({
  mainParents,
  title,
  icon,
  selPlaceholder,
  setSelectedIds,
  selectedIds,
}) => {
  
  const { t } = useTranslation();
  const [selectedMainParents, setSelectedMainParents] = useState([]);
  const [showMultipleDepartmentsModal, setShowMultipleDepartmentsModal] = useState(false);

  const handleRemoveClick = (parentId) => {
    const selectedUpdate = selectedMainParents.filter((selected) => selected.id !== parentId);
    const updatedRemoveIds = selectedUpdate.map((x) => x.id);
    setSelectedMainParents(selectedUpdate);
    setSelectedIds(updatedRemoveIds);
  };

  const handleAddItems = (newData) => {
    const updatedIds = newData.map((x) => x.id);
    setSelectedMainParents(newData);
    setSelectedIds(updatedIds);
  };
  
  useEffect(() => {
    if (selectedIds && mainParents.length > 0) {
      const selectedItems = mainParents && mainParents.length > 0 && mainParents.filter((item) =>
        selectedIds.includes(parseInt(item.id))
      );
      setSelectedMainParents(selectedItems);
    }
  }, [selectedIds, mainParents]);

  return (
    <MultipleDepartmentsRow>
      <SelectedMultipleDepartmentsList
        selectedMainParents={selectedMainParents}
        onRemoveClick={handleRemoveClick}
      />
      <MultipleTogglePopup
        icon={icon}
        selPlaceholder={t(selPlaceholder)}
        setShowMultipleDepartmentsModal={setShowMultipleDepartmentsModal}
      />
      <MultipleDepartmentsModal
        title={t(title)}
        show={showMultipleDepartmentsModal}
        onHide={() => setShowMultipleDepartmentsModal(false)}
        mainParents={mainParents}
        selectedMainParents={selectedMainParents}
        setSelectedMainParents={handleAddItems}
      />
    </MultipleDepartmentsRow>
  );
};

export default AddMultipleDepartments;

const MultipleDepartmentsRow = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
`;
